<template>

  <div>
    <v-snackbar
      :value="value"
      absolute
      right
      :timeout="timeout"
      color="success"
      top
    >
      data berhasil di upload
    </v-snackbar>

     
    <v-expansion-panels class="mt-5">
      <v-expansion-panel
        
      >
        <v-expansion-panel-header>Filtering Data</v-expansion-panel-header>
        <v-expansion-panel-content>
          
      <v-row>
        <v-col cols="12" md="6" sm="12">
          <v-file-input
            class="mt-2"
            v-model="filename"
            accept=".xlsx"
            id="excel_target"
            placeholder="format upload wajib .xlsx"
            ref="post_title"
            @change="impexcel()"
          ></v-file-input>
        </v-col>
        <v-col cols="3" md="2" class="mt-5">
          <v-btn
            class="md-2"
            color="#5E50A1"
            :loading="loading"
            :disabled="disable"
            @click="postData"
            style="color:#fff"
          >
            UPLOAD FILE
          </v-btn>
        </v-col>
        <v-col cols="3" md="2" class="mt-5">
          <SampleExcel :sheets="sheet" :fname="fname"/>
        </v-col>
      </v-row>
  
  <v-row>
     
    <v-col
          md="2"
    >
      <v-text-field
          label="origin"
          hide-details
          :value="filterQry.qryOrigin"
          @change="filterOrigin"
        ></v-text-field>
    </v-col>
    <v-col
          md="2"
    >
      <v-text-field
          label="destination"
          hide-details
          :value="filterQry.qryDest"
          @change="filterDestination"
        ></v-text-field>
    </v-col>
    <v-col
          md="2"
    >
      <v-text-field
          label="service"
          hide-details
          :value="filterQry.qryService"
          @change="filterService"
        ></v-text-field>
        

    </v-col>
      <!-- <v-btn @click="filterItemsForBackup" class="ml-1 success">Backup Data</v-btn> -->
      <v-btn @click="filterItems" style="background-color:rgb(94, 80, 161);color:white" class="mt-5">Filter</v-btn>
      <v-btn @click="deleteFilter" class="ml-1 warning mt-5" >Hapus</v-btn>
      <ExportTable class="ml-1 mt-5" :sheets="exportdata" :fname="filenameBackup" v-show="!vBtn"/>
   </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
   
    <v-skeleton-loader v-if="firstLoad" :loading="loading" type="table"></v-skeleton-loader>
    
      <v-row class="mt-5">
        <v-col
         
          cols="3"
          sm="2"
        >
          <v-select
            :items="showData"
            label="show"
            v-show="!firstLoad"
            outlined
            :value="defaultShow"
            @input="handleFilterShowData"
          ></v-select>
    </v-col>
    <v-col  
     
      cols="3"
      sm="2">
      <p v-show="!firstLoad" class="mx-2 mt-3">Total Data :{{totalData}}</p>
    </v-col>
    
      </v-row>
 
   
    <v-data-table
    dense
      :headers="headers"
      ref="ownershipContent"
      :items="data"
      v-show="!firstLoad"
      :fixed-header="true"
      item-key="no"
      :search="search"
      :page.sync="page"
      :items-per-page="100"
      hide-default-footer=""
      @page-count="pageCount = $event"
      class="mt-5 elevation-5"
      style="padding: 15px"
      :options.sync="options"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.OriginAdminHub}}</td>
          <td>{{ row.item.DestinationAdminHub}}</td>
          <td>{{ row.item.OriginLockerCode}}</td>
          <td>{{ row.item.DestinationLockerCode}}</td>
          <td>{{ row.item.Origin}}</td>
          <td>{{ row.item.Destination }}</td>
          <td>{{ row.item.Type}}</td>
          <td>{{ row.item.Service }}</td>
          <td>{{ row.item.Via }}</td>
          <td>{{ row.item.Fm }}</td>
          <td>{{ row.item.FeederIntraPhOutbound }}</td>
          <td>{{ row.item.FeederInterPhOutbound }}</td>
          <td>{{ row.item.Linehaul_1 }}</td>
          <td>{{ row.item.Linehaul_2 }}</td>
          <td>{{ row.item.Linehaul_3 }}</td>
          <td>{{ row.item.Linehaul_4 }}</td>
          <td>{{ row.item.Linehaul_5 }}</td>
          <td>{{ row.item.Linehaul_6 }}</td>
          <td>{{ row.item.Linehaul_7 }}</td>
          <td>{{ row.item.Linehaul_8 }}</td>
          <td>{{ row.item.FeederInbound }}</td>
          <td>{{ row.item.FeederIntraPhInbound }}</td>
          <td>{{ row.item.Lm }}</td>
          <td>{{ row.item.PpOrigin }}</td>
          <td>{{ row.item.PhOrigin }}</td>
          <td>{{ row.item.Transit_1 }}</td>
          <td>{{ row.item.Transit_2 }}</td>
          <td>{{ row.item.Transit_3 }}</td>
          <td>{{ row.item.Transit_4 }}</td>
          <td>{{ row.item.Transit_5 }}</td>
          <td>{{ row.item.Transit_6 }}</td>
          <td>{{ row.item.Transit_7 }}</td>
          <td>{{ row.item.Transit_8 }}</td>
          <td>{{ row.item.PpDestination }}</td>
          <td>{{ row.item.PhDestination }}</td>
          <td>{{ row.item.Consumeables }}</td>
          <td>{{ row.item.Commission }}</td>
          <td>{{ row.item.PpCommission }}</td>
          <td>{{ row.item.CosOrShipment }}</td>
          <td>{{ row.item.PublishPrice }}</td>
          <td>{{ row.item.GrossMarginOrShip }}</td>
          <td>{{ row.item.CrosFrozenHandling }}</td>
          <td>{{ row.item.PriceFrozenHandling }}</td>
          <td>{{ row.item.GrossMarginIncFrozenHandling }}</td>
          <td>{{ row.item.GrossMarginNotIncFrozenHandlingPersen }}</td>
          <td>{{ row.item.GrossMarginIncFrozenHandlingPersen }}</td>
          <td>{{ row.item.Size }}</td>
          <td>{{ row.item.UploadedBy }}</td>
          <td>{{ row.item.CreatedAt.substring(0,10) }}</td>
          <td>
            <div style="padding: 5px">
              <v-btn v-model="mirrorId" color="red" small  @click="delUpload(row.item.ID)" 
                ><v-icon small color="white">
                  mdi-delete
                </v-icon></v-btn
              >
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div style="display: flex; justify-content: end; margin-top: 20px">
      <p class="mt-2" v-show="!firstLoad">page {{ page }} to {{ RecordsTotal }}</p>
      <v-pagination
        v-show="!firstLoad"
        v-model="page"
        :length="RecordsTotal"
        :total-visible="5"
        color="#5E50A1"
        :options.sync="options"
        @input="handlePageChange"
      >
      </v-pagination>
    </div>
    <!-- {{ filteredItems }} -->
  </div>
</template>
<script>
import readXlsFile from "read-excel-file";
import SampleExcel from "@/components/SampleExcel.vue";
import ExportTable from "@/components/ExportTable.vue";
import moment from "moment";

export default {
  props:['sheet','fname'],
  components:{
    SampleExcel,
    ExportTable
  },
  data: () => ({
    timeout: 3000,
    search:'',
    vBtn:false,
    filenameBackup:"uec_back_up.xlsx",
    firstLoad: true,
    filename: null,
    mirrorId: [],
    page: 1,
    defaultShow:15,
    showData:[15,25,50,100],
    RecordsTotal:null,
    RecordsFiltered:null,
    itemsPerPage: null,
    totalData:null,
    options: {},
    value: false,
    idSegment: [],
    disable: false,
    pageCount: 0,
    itemsPerPage: 20,
    items: null,
    exportdata:[{
      name: "SheetOne",  
      data: null
    }],
    loading: false,
    headers: [
      { id: 1, text: "OriginAdminHub", value: "OriginAdminHub" },
      { id: 2, text: "DestinationAdminHub", value: "DestinationAdminHub" },
      { id: 3, text: "OriginLockerCode", value: "OriginLockerCode" },
      { id: 4, text: "DestinationLockerCode", value: "DestinationLockerCode" },
      { id: 5, text: "Origin", value: "Origin" },
      { id: 6, text: "Destination", value: "Destination" },
      { id: 7, text: "Type", value: "Type" },
      { id: 8, text: "Service", value: "Service" },
      { id: 9, text: "Via", value: "Via" },
      { id: 10, text: "Fm", value: "Fm" },
      { id: 11, text: "FeederIntraPhOutbound", value: "FeederIntraPhOutbound" },
      { id: 12, text: "FeederInterPhOutbound", value: "FeederInterPhOutbound" },
      { id: 13, text: "Linehaul1", value: "Linehaul1" },
      { id: 14, text: "Linehaul2", value: "Linehaul2" },
      { id: 15, text: "Linehaul3", value: "Linehaul3" },
      { id: 16, text: "Linehaul4", value: "Linehaul4" },
      { id: 17, text: "Linehaul5", value: "Linehaul5" },
      { id: 18, text: "Linehaul6", value: "Linehaul6" },
      { id: 19, text: "Linehaul7", value: "Linehaul7" },
      { id: 20, text: "Linehaul8", value: "Linehaul8" },
      { id: 21, text: "FeederInbound", value: "FeederInbound" },
      { id: 22, text: "FeederIntraPhInbound", value: "FeederIntraPhInbound" },
      { id: 23, text: "Lm", value: "Lm" },
      { id: 24, text: "PpOrigin", value: "PhOrigin" },
      { id: 24, text: "PhOrigin", value: "PhOrigin" },
      { id: 25, text: "Transit1", value: "Transit1" },
      { id: 26, text: "Transit2", value: "Transit2" },
      { id: 27, text: "Transit3", value: "Transit3" },
      { id: 28, text: "Transit4", value: "Transit4" },
      { id: 29, text: "Transit5", value: "Transit5" },
      { id: 30, text: "Transit6", value: "Transit6" },
      { id: 31, text: "Transit7", value: "Transit7" },
      { id: 32, text: "Transit8", value: "Transit8" },
      { id: 33, text: "PpDestination", value: "PhDestination" },
      { id: 33, text: "PhDestination", value: "PhDestination" },
      { id: 34, text: "Consumeables", value: "Consumeables" },
      { id: 35, text: "Commission", value: "Commission" },
      { id: 36, text: "PpCommission", value: "PpCommission" },
      { id: 37, text: "CosOrShipment", value: "CosOrShipment" },
      { id: 38, text: "PublishPrice", value: "CosOrShipment" },
      { id: 38, text: "GrossMarginOrShip", value: "GrossMarginOrShip" },
      { id: 38, text: "CrosFrozenHandling", value: "CrosFrozenHandling" },
      { id: 38, text: "PriceFrozenHandling", value: "CosOrShipment" },
      { id: 39, text: "GrossMarginIncFrozenHandling", value: "GrossMarginIncFrozenHandling" },
      { id: 40, text: "GrossMarginNotIncFrozenHandlingPersen", value: "GrossMarginNotIncFrozenHandlingPersen" },
      { id: 41, text: "GrossMarginIncFrozenHandlingPersen", value: "GrossMarginIncFrozenHandlingPersen" },
      { id: 42, text: "Size", value: "Size" },
      { id: 43, text: "UploadedBy", value: "UploadedBy" },
      { id: 43, text: "CreatedAt", value: "UploadedBy" },
      { id: 44, text: "Action", value: "butn" },
    ],
    data: [],
    filterQry: {
      qryOrigin: "",
      qryDest: "",
      qryService: "",
    }
  }),
  watch: {
    options: {
      handler() {
        console.log("options watcher called");
       // this.getItem();
      },
      deep: true,
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  methods: {
    getItem(x) {
      //console.log("get Item" + JSON.stringify(x))
      const length = x.limit

      this.$store
        .dispatch("getUploadDataUecPnl",x)
        .then((response) => {
          //console.log(this.data)
          if (response.data.code == 200) {
           
            const item = response.data.data;
              if(item.records.length == 0){
                  this.data = []
                  this.totalData = 0
                  this.RecordsTotal =1
                  this.exportdata[0].data = [{}]
                  this.vBtn=true
                  this.firstLoad=true
                 
              }
            // console.log(item)
            this.firstLoad=false
            // item.records.forEach((x) => {   
              let z = item.RecordsFiltered
              if (length !== 0) {
                z = item.RecordsTotal / length
              }
              
              this.itemsPerPage = item.RecordsFiltered
              this.RecordsTotal = Math.ceil(z)
              this.data = item.records  
              this.exportdata[0].data = item.records 
              this.totalData = item.RecordsTotal
             
            // });
          }
        })
        .catch(function (error) {});
    },
    getItemForBackup(x) {
      //console.log("get Item" + JSON.stringify(x))
      const length = x.limit
      this.$store
        .dispatch("getUploadDataUecPnl",x)
        .then((response) => {
          //console.log( response.data.data)
          if (response.data.code == 200) {
           
            const item = response.data.data;
            if(item.records.length == 0){
              this.exportdata[0].data = [{}]
              this.vBtn=true
              alert("data kosong")
            } else {
              this.exportdata[0].data = item.records 
              this.vBtn=false
            }
            //backup into xlsx
            // console.log(this.exportdata[0].data)
            // const data = XLSX.utils.json_to_sheet(this.exportdata[0].data)
            // const wb = XLSX.utils.book_new()
            // XLSX.utils.book_append_sheet(wb, data, 'data')
            // XLSX.writeFile(wb,'uec_back_up.xlsx')
          }
        })
        .catch(function (error) {});
    },
    formatDate(value) {
      //console.log("ini moment " + value)
      return moment(value).format("YYYY-MM-DD")
    },
    impexcel() {
      const input = document.getElementById("excel_target");
      readXlsFile(input.files[0]).then((rows) => {
        this.items = rows;
        let keys = this.items[0];

        let newArr = this.items.slice(1, this.items.length);

        let formatted = [],
          data = newArr,
          cols = keys,
          l = cols.length;
        for (let i = 0; i < data.length; i++) {
          let d = data[i],
           
            o = {};
          for (let j = 0; j < l; j++) o[cols[j]] = d[j];
          
           let margin_inc_persen = o['gross_margin_inc_frozen_handling_persen']/100
           let margin_not_inc_persen = o['gross_margin_not_inc_frozen_handling_persen']/100 
           o['gross_margin_inc_frozen_handling_persen'] = margin_inc_persen
           o['gross_margin_not_inc_frozen_handling_persen'] = margin_not_inc_persen 
      
          formatted.push(o);
        }
        this.items = formatted;
      });
    },
    postData() {
      const data = { items: this.items };
      this.loading = true;
      if (this.filename) {
        const data = { items: this.items };
        this.loading = true;
        this.disable = false;
        this.$store
          .dispatch("postUploadDataUecPnl", data)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              this.value = true;
              this.filename = null;

              setTimeout(() => (this.loading = false), 1500);
              this.$router.go(this.$router.currentRoute);
              //this.getItem({limit:this.defaultShow,page:1});
            }
          })
          .catch(function (error) {
            alert("Data Gagal di Upload")
            console.log(error);
            this.$router.go(this.$router.currentRoute);
          });
      } else {
        this.loading = true
        alert("upload data tidak boleh kosong") 
        this.$router.go(this.$router.currentRoute);
      }
    },
    delUpload(id) {
      this.$swal({
        title: "Hapus Data? ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5E50A1",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("delUploadDataUecPnl", id).then((response) => {
            console.log(response);
            this.$swal("Berhasil dihapus").then((result) => {
              console.log(result);
              if (result.value) {
                //this.$router.go(this.$router.currentRoute);
                //")
                this.getItem({limit:this.defaultShow,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService})
              }
            });
          });
        }
      });
    },
    deleteFilter(){
      this.filterQry.qryOrigin  = ""
      this.filterQry.qryDest  = ""
      this.filterQry.qryService  = ""
      this.filterItemsForBackup()
      this.getItem({limit:this.defaultShow,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService})
    },
    filterOrigin(val) {
      this.filterQry.qryOrigin = val;
     
    },
    filterDestination(val) {
      this.filterQry.qryDest = val;
    },
    filterService(val) {
      this.filterQry.qryService = val;
    },
    filterItems() {
     // alert("tess")
      this.getItem({limit:this.defaultShow,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService})
    },
    filterItemsForBackup() {
      this.getItemForBackup({limit:-1,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService})
    },
    handlePageChange(value) {
      let payload={limit:this.defaultShow,page:value,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService}
      this.page = payload.page
      this.getItem(payload)
    },
    handleFilterShowData(x){
      console.log(this.page)
      let payload={limit:x,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService}
      this.defaultShow = x
      this.page=1
      this.getItem(payload)
    }
  },
  mounted() {
    console.log("mounteed")
    this.getItem({limit:this.defaultShow,page:1,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService})
    this.filterItemsForBackup()

  },
};
</script>
<style scoped>
.v-input__slot {
  min-height: 45px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.875rem;
    padding: 0px 7px;
    font-size: 12px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 0 30px !important;
}
.v-application .ml-5 {
    margin-left: 70px !important;
}
</style>